import React from 'react';
import PropTypes from 'prop-types';
import './Key.css';

export default function Key({ children, onClick, keyboardLetters }) {
    let bgColor = '';
    if (keyboardLetters !== null) {
        for (let index = 0; index < keyboardLetters.correct.length; index += 1) {
            if (children === keyboardLetters.correct[index]) {
                bgColor = '#6aaa64';
                break;
            }
        }
    }
    if (keyboardLetters !== null) {
        for (let index = 0; index < keyboardLetters.misplaced.length; index += 1) {
            if (children === keyboardLetters.misplaced[index]) {
                bgColor = '#cab458';
                break;
            }
        }
    }
    if (keyboardLetters !== null) {
        for (let index = 0; index < keyboardLetters.wrong.length; index += 1) {
            if (children === keyboardLetters.wrong[index]) {
                bgColor = '#787c7e';
                break;
            }
        }
    }
    const style = {
        background: bgColor,
    };

    if (children === 'a') {
        return (
            <>
                <button type="button" onClick={onClick} style={style} className="keyboard-key-a">
                    {children}
                </button>
            </>
        );
    }

    if (children === 'ENTER') {
        return (
            <>
                <button type="button" onClick={onClick} style={style} className="keyboard-key-enter">
                    {children}
                </button>
            </>
        );
    }

    if (children === '<<') {
        return (
            <>
                <button type="button" onClick={onClick} style={style} className="keyboard-key-backspace">
                    {children}
                </button>
            </>
        );
    }

    return (
        <>
            <button type="button" onClick={onClick} style={style} className="keyboard-key">
                {children}
            </button>
        </>
    );
}

Key.defaultProps = {
    children: '',
    onClick: null,
    keyboardLetters: null,
};

Key.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(Object),
    ]),
    onClick: PropTypes.func,
    keyboardLetters: PropTypes.instanceOf(Object),
};
